import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";

import { map } from "rxjs/operators";
import { UserForm } from "app/interfaces/user-form.interface";
import { DeviceForm } from "app/interfaces/device-form.interface";
import { VideoRecordRegisterInfoForm } from "app/interfaces/videorecord/videorecord-register-info-form.interface";
import { VideoRecordCameraInfoForm } from "app/interfaces/videorecord/videorecord-camera-info-form.interface";
import { VideoRecordVersionInfoForm } from "app/interfaces/videorecord/videorecord-version-info-form.interface";

const devicesUrlApi = environment.devicesUrlApi;
const devicesNotAssignedUrlApi = environment.devicesNotAssignedUrlApi;
const devicesAliveUrlApi = environment.devicesAliveUrlApi;
const devicesOwnUrlApi = environment.devicesOwnUrlApi;
const devicesUserUrlApi = environment.devicesUserUrlApi;
const devicesWithFiltersUrlApi = environment.devicesWithFiltersUrlApi;
const devicescheckSettingsDeviceUrlApi =
  environment.devicescheckSettingsDeviceUrlApi;

@Injectable()
export class DeviceService {
  public user: UserForm;

  constructor(private http: HttpClient) {}

  getDevices() {
    return this.http
      .request("GET", `${devicesUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getDevicesNotAssigned() {
    return this.http
      .request("GET", `${devicesNotAssignedUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getDevicesAlive() {
    return this.http
      .request("GET", `${devicesAliveUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getOwnDevices() {
    return this.http
      .request("GET", `${devicesOwnUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getDevicesUser(id: number) {
    return this.http
      .request("GET", `${devicesUserUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  /* getDevicesWithFilter(filters) {
    const params = filters;
    console.log(params);
    return this.http
      .post(`${devicesWithFiltersUrlApi}`, params)
      .pipe(map((resp: any) => resp));
  } */

  getDeviceById(id: number) {
    return this.http
      .request("GET", `${devicesUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  updateDeviceById(id: number, deviceModel: DeviceForm) {
    deviceModel.auto_upgrade =
      deviceModel.auto_upgrade == true ? Number(1) : Number(0);
    const body = deviceModel;
    return this.http
      .request("PUT", `${devicesUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  updateVideoRecordInfo(
    id: number,
    device_name: string,
    cameraInfo: VideoRecordCameraInfoForm,
    registerInfo: VideoRecordRegisterInfoForm,
    versionInfo: VideoRecordVersionInfoForm
  ) {
    let d = { RegisterInfo: {}, VersionInfo: {}, CameraInfo: {} };
    d.RegisterInfo = registerInfo;
    d.VersionInfo = versionInfo;
    d.CameraInfo = cameraInfo;
    let data: string;
    let did: string = "aa";
    let body = { device_name, data, did };
    body.data = JSON.stringify(d);
    return this.http
      .request("PUT", `${devicesUrlApi}/` + id, { body })
      .pipe(map((resp: any) => resp));
  }

  createDevice(deviceModel: DeviceForm) {
    deviceModel.data = JSON.stringify(deviceModel.data);
    deviceModel.auto_upgrade =
      deviceModel.auto_upgrade == true ? Number(1) : Number(0);

    const body = deviceModel;
    return this.http
      .request("POST", `${devicesUrlApi}`, { body })
      .pipe(map((resp: any) => resp));
  }

  deleteDeviceById(id: number) {
    return this.http
      .request("DELETE", `${devicesUrlApi}/` + id, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  deleteDeviceUser(id: number) {
    // const body = { id_user: idUser, id_device: idDevice };
    return this.http
      .request("DELETE", `${devicesUserUrlApi}`, {})
      .pipe(map((resp: any) => resp));
  }
}
